var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38983 1.83082C7.7042 1.93561 7.8741 2.2754 7.76931 2.58977L5.36931 9.78977C5.26452 10.1041 4.92473 10.274 4.61036 10.1692C4.29599 10.0645 4.1261 9.72466 4.23089 9.41029L6.63089 2.21029C6.73568 1.89593 7.07547 1.72603 7.38983 1.83082ZM3.42436 3.77576C3.65868 4.01008 3.65868 4.38998 3.42436 4.62429L2.04863 6.00003L3.42436 7.37576C3.65868 7.61008 3.65868 7.98998 3.42436 8.22429C3.19005 8.45861 2.81015 8.45861 2.57583 8.22429L0.775834 6.42429C0.541519 6.18998 0.541519 5.81008 0.775834 5.57576L2.57583 3.77576C2.81015 3.54145 3.19005 3.54145 3.42436 3.77576ZM8.57583 3.77576C8.81015 3.54145 9.19005 3.54145 9.42436 3.77576L11.2244 5.57576C11.4587 5.81008 11.4587 6.18998 11.2244 6.42429L9.42436 8.22429C9.19005 8.45861 8.81015 8.45861 8.57583 8.22429C8.34152 7.98998 8.34152 7.61008 8.57583 7.37576L9.95157 6.00003L8.57583 4.62429C8.34152 4.38998 8.34152 4.01008 8.57583 3.77576Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSlash);
export default __webpack_public_path__ + "static/media/code-slash.6b788cc2d9f56f5996857887c0a129ef.svg";
export { ForwardRef as ReactComponent };